import { ClipboardDocumentIcon, CheckIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useEffect } from 'react';
import { Stack, TextField, Tooltip } from 'ui-components';
import { twMerge } from 'tailwind-merge';

type Props = {
  textToCopy: string;
  className?: string;
};

export function InputFieldCopier({ textToCopy, ...props }: Props) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let id: NodeJS.Timeout;
    if (copied) {
      id = setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
    return () => {
      clearTimeout(id);
    };
  }, [copied]);

  const Icon = copied ? CheckIcon : ClipboardDocumentIcon;
  const defaultClasses = 'text-zinc-500 w-52';
  const classes = twMerge(defaultClasses, props.className);

  return (
    <Stack direction="row" gap={1} className="relative">
      <TextField name="url" value={textToCopy} className={classes} readOnly />

      <div className="absolute -right-10">
        <Tooltip text="Kopiert!" trigger="click">
          <CopyToClipboard text={textToCopy} onCopy={() => setCopied(true)}>
            <div className="flex w-9 h-9 p-1.5 items-center justify-center rounded-full text-primary-600 cursor-pointer hover:bg-gray-100">
              <Icon className="w-5 h-5" />
            </div>
          </CopyToClipboard>
        </Tooltip>
      </div>
    </Stack>
  );
}
